import React from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators, compose} from 'redux';
import {connect} from 'react-redux';
import {firebaseConnect, isLoaded} from 'react-redux-firebase';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import {addLocaleData, IntlProvider} from 'react-intl';
import englishLocaleData from 'react-intl/locale-data/en';
import frenchLocaleData from 'react-intl/locale-data/fr';
import 'moment/locale/fr-ca';
import 'moment/locale/en-ca';
import * as Sentry from '@sentry/browser';
import _ from 'lodash';

import {Error, Loading, Snackbars} from './components/common';
import Routes from './Routes';

import * as snackbarActions from './actions/snackbarActions';

import styles from './components/common/styles';
import {ROLE_TYPES} from "./constants/roleTypes";

const darkTheme = createMuiTheme({
    ...styles._theme()
});

class App extends React.Component {
    constructor(props){
        super();

        this.isLoaded = this.isLoaded.bind(this);

        this.state = {
            error: null,
            notifyRefresh: false
        };

        addLocaleData([...englishLocaleData, ...frenchLocaleData]);
        Sentry.configureScope(scope => {
            scope.setTag('page_locale', props.intl.locale);
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.releaseDate && this.props.releaseDate && prevProps.releaseDate !== this.props.releaseDate) {
            this.props.snackbarActions.addSnackbar({
                message: 'A new version is available. Please refresh.',
                variant: 'info'
            });
        }
        if (prevProps.intl.locale !== this.props.intl.locale) {
            Sentry.configureScope(scope => {
                scope.setTag('page_locale', this.props.intl.locale);
            });
        }
    }

    componentDidCatch(error, errorInfo) {
        Sentry.withScope(scope => {
            scope.setExtra('location', this.props.location);
            Object.keys(errorInfo).forEach(key => {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });
        this.setState({error});
    }

    isLoaded() {
        const auth = this.props.firebase.auth();
        const profile = this.props.profile;
        return isLoaded(auth) && profile.isLoaded;
    }

    render() {
        const {locale, messages} = this.props.intl;
        return (
            <IntlProvider key={locale} locale={locale} messages={messages}>
                <MuiThemeProvider theme={darkTheme}>
                    {do {
                        if (this.state.error && !this.props.location.pathname.includes("dashboard")) {
                            <Error/>;
                        }
                        else if (this.isLoaded()) {
                            <Routes profile={this.props.profile}/>;
                        } else {
                            <Loading/>;
                        }
                    }}
                    <Snackbars/>
                </MuiThemeProvider>
            </IntlProvider>
        );
    }
}

App.propTypes = {
    firebase: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    snackbarActions: PropTypes.objectOf(PropTypes.func)
};

function mapStateToProps(state) {
    const profile = state.firebase.profile;
    profile.isSuperAdmin = _.get(profile, 'role', []).includes(ROLE_TYPES.SUPER_ADMIN.key);
    profile.isAdmin = _.get(profile, 'role', []).includes(ROLE_TYPES.ADMIN.key) || profile.isSuperAdmin;
    return {
        intl: state.intl,
        profile,
        releaseDate: state.firebase.data.releaseDate
    };
}

function mapDispatchToProps(dispatch) {
    return {
        snackbarActions: bindActionCreators(snackbarActions, dispatch)
    };
}

export default compose(
    firebaseConnect(['releaseDate']),
    connect(mapStateToProps, mapDispatchToProps)
)(App);


// WEBPACK FOOTER //
// ./src/App.js